import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { svSE } from '@clerk/localizations';
import { clerkSatellite } from './clerk-config.js';
import { App } from './App.js';
import { ErrorBoundary, installGlobalErrorHandlers } from './ErrorBoundary.js';
import './index.css';

installGlobalErrorHandlers();

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

const publishableKey = import.meta.env['VITE_CLERK_PUBLISHABLE_KEY'] as
  | string
  | undefined;
if (!publishableKey) {
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required (run `pnpm sync-env`)');
}


createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <ClerkProvider publishableKey={publishableKey} localization={svSE} {...clerkSatellite}>
        <App />
      </ClerkProvider>
    </ErrorBoundary>
  </StrictMode>,
);
